import {combineReducers} from '@modifi/redux'

import refinancingPartnersReducer from './available-refinancing-partners/store'
import splitTransactionReducer from './split-transaction/store'
import deleteTransactionReducer from './delete-transaction/store'
import tagTransactionReducer from './tag-transaction/store'
import linkDocumentReducer from './link-document/store'
import unlinkDocumentReducer from './unlink-document/store'
import passThroughTransactionReducer from './pass-through-transaction/store'

export default combineReducers({
  refinancingPartners: refinancingPartnersReducer,
  splitTransaction: splitTransactionReducer,
  deleteTransaction: deleteTransactionReducer,
  tagTransaction: tagTransactionReducer,
  link: linkDocumentReducer,
  unlink: unlinkDocumentReducer,
  passThroughTransaction: passThroughTransactionReducer,
})
